import DOMPurify from 'dompurify';

// Force external links to open safely in a new tab
DOMPurify.addHook('afterSanitizeAttributes', (node) => {
  if (node.tagName === 'A' && node.getAttribute('href')) {
    node.setAttribute('target', '_blank');
    node.setAttribute('rel', 'noopener noreferrer');
  }
});

const CONFIG = {
  USE_PROFILES: { html: true },
  FORBID_TAGS: ['style', 'script', 'iframe', 'object', 'embed', 'form', 'input'],
  FORBID_ATTR: ['style', 'onerror', 'onload'],
  ADD_ATTR: ['target'],
};

export const sanitizeHtml = (html) => {
  if (!html) return '';
  return DOMPurify.sanitize(html, CONFIG);
};
